export default "__VITE_ASSET__962341e8__"